import { useQuery } from '@tanstack/react-query';
import { getRichMessageTemplates } from 'api/richMessageTemplates';
import { queryKeys } from 'constants/queryKeys';
import { findRichMessageTemplate } from 'constants/richMessageTemplates';
import type { TRichMessageTemplate } from 'types/richMessage';

export function useRichMessageTemplates() {
  return useQuery({
    queryKey: [queryKeys.RICH_MESSAGE_TEMPLATES],
    queryFn: getRichMessageTemplates,
    staleTime: 1000 * 60 * 60,
  });
}

export function useRichMessageTemplate(
  templates: TRichMessageTemplate[] | undefined,
  templateId: string | undefined,
) {
  return findRichMessageTemplate(templates, templateId ?? '');
}
